
const network = require( './network/network_api' );
import { FINISHING_STATES } from "./slot";
import Autoplay from "./autoplay";
import Stream from "./frp/stream";
import { get_prop } from 'utils'

export default function(
    parent,
    $credits,
    config,
    leaf,
)
{
    const space = parent.child( "ui" );
    
    $credits.subscribe( leaf.s( "credits" ) );
    
    const $state = parent.s( "state" );
    
    const $userBet = space.s( "userBet" ).description( "Last user inputted bet or retrieved from server. Used to restore bet." );
    const $resultBet = space.s( "resultBet" ).description( "What bet player currently sees." );
    
    //отмена какого-либо сохранения ставки пользователя (по сравнению со ставкой при автоматическом её падении например) если сервер сказал этого НЕ делать:
    $resultBet
        .map( ({ bet }) => bet )
        .with( $state, ( bet, s ) => ({
            bet,
            bet_recover : get_prop( s.server.loginData, [ 'settings', 'features', 'bet_recover' ], false )
        }) )
        //resetting userBet when server told to NOT recover:
        .filter( ({ bet_recover }) => ! bet_recover )
        .map( ({ bet }) => bet )
        //prevent $userBet -> $resultBet -> $userBet recursion:
        .changed( ( prev_v, new_v ) => _.isEqual( prev_v, new_v ) )
        .to( $userBet );
    
    //cannot use $resultBet directly because polling tries to reset bet back to server's value:
    $state
        //попросили убрать поднятие ставки (и, как я понимаю, вообще её какое-либо изменение) при изменении кредитов:
        //.take( 1 )
        .map( state => state.server.bet )
        .to( $userBet );
    
    $state
        .any(
            $credits,
            leaf.s( "canBet" ),
            $userBet,
            ( state, _, canBet, userBet ) => ({ state, canBet, userBet })
        )
        .with( $resultBet, ( { state, canBet, userBet }, resultBet ) => ({ state, canBet, userBet, resultBet }) )
        .map( ({ state, canBet, userBet, resultBet }) => ({
            bet : canBet ? state.server.shrink( userBet ) : ( resultBet ? resultBet.bet : state.server.bet ),
            state
        }) )
        .to( $resultBet );
    $resultBet
        .map( c => c.state.server.betToValue( c.bet ) )
        .to( leaf.s( "betValue" ) );
    $resultBet
        .map( c => c.state.server.betToValue( c.bet ).lines )
        .to( leaf.s( "linesValue" ) );
    $resultBet
        .map( c => c.state.server.betToValue( c.bet ).multiplier )
        .to( leaf.s( "multiplierValue" ) );
    $resultBet
        .map( c => c.state.server.price( c.bet ) )
        .to( leaf.s( "price" ) );
    leaf.s( 'price' )
        .with( parent.s( 'state' ), ( price, state ) => price * state.state.credit_price )
        .name( leaf, 'money_price' )
    $resultBet
        .map( c => ! c.state.server.cannotPay( c.bet ) )
        .to( leaf.s( "canPay" ) );
    
    function min_lines( state, bet ) {
        while (
            state.server.price( bet ) < state.server.min_bet
            &&
            bet.lines < config.lines.length - 1
        ) {
            ++ bet.lines
        }
    }
    function min_mult( state, bet ) {
        while (
            state.server.price( bet ) < state.server.min_bet
            &&
            bet.multiplier < config.multipliers.length - 1
        ) {
            ++ bet.multiplier
        }
    }
    
    leaf.s( "increaseLines" )
        .with( $resultBet, ( intent, c ) => c )
        .on( ({ bet, state }) =>
        {
            const r = {
                lines : bet.lines < config.lines.length - 1 ? bet.lines + 1 : 0,
                multiplier : bet.multiplier,
            };
            if ( state.server.cannotPay( r ) ) r.lines = 0;
            
            min_lines( state, r )

            $userBet.next( state.server.shrink( r ) );
        } );
    
    leaf.s( "decreaseLines" )
        .with( $resultBet, ( intent, c ) => c )
        .on( ({ bet, state }) =>
        {
            const r = {
                lines : bet.lines > 0 ? bet.lines - 1 : config.lines.length - 1,
                multiplier : bet.multiplier,
            };
            while ( state.server.cannotPay( r ) && r.lines > 0 ) -- r.lines
            
            min_lines( state, r )

            $userBet.next( state.server.shrink( r ) );
        } );
    
    leaf.s( "increaseMultiplier" )
        .with( $resultBet, ( intent, c ) => c )
        .on( ({ bet, state }) =>
        {
            const r = {
                lines : bet.lines,
                multiplier : bet.multiplier < config.multipliers.length - 1 ? bet.multiplier + 1 : 0,
            };
            if ( state.server.cannotPay( r ) ) r.multiplier = 0;
            
            min_mult( state, r )

            $userBet.next( state.server.shrink( r ) );
        } );
    
    leaf.s( "decreaseMultiplier" )
        .with( $resultBet, ( intent, c ) => c )
        .on( ({ bet, state }) =>
        {
            const r = {
                lines : bet.lines,
                multiplier : bet.multiplier > 0 ? bet.multiplier - 1 : config.multipliers.length - 1,
            };
            while ( state.server.cannotPay( r ) && r.multiplier > 0 ) -- r.multiplier
            
            min_mult( state, r )

            $userBet.next( state.server.shrink( r ) );
        } );
    
    leaf.s( "setLines" )
        .with( $resultBet, ( intent, c ) => ({ intent, bet : c.bet, state : c.state }) )
        .on( ({ intent, bet, state }) =>
        {
            const r = {
                lines : intent,
                multiplier : bet.multiplier,
            };
            
            while ( state.server.cannotPay( r ) && r.lines > 0 ) -- r.lines
            
            min_lines( state, r )

            $userBet.next( state.server.shrink( r ) );
        } );
    
    Stream.any(
        parent.s( "net" ),
        parent.s( "animating" ),
        parent.s( "pending" ),
        ( net, animating, pending ) =>
            net.state.type == network.TYPE.FINAL
            &&
            ! animating
            &&
            pending === undefined
    )
    .distinctUntilChanged()
    .to( leaf.s( "canBet" ) );
    
    $resultBet
        .map( ({ bet, state }) => _.isEqual(
            state.server.shrink( bet ),
            state.server.shrink( { lines : bet.lines > 0 ? 0 : 1, multiplier : bet.multiplier } )
        ) )
        .map( doesNothing => ! doesNothing )
        .to( leaf.s( "canChangeLines" ) );
    
    const $multiplierChangeDoesNothing = $resultBet
        .map( ({ bet, state }) => _.isEqual(
            state.server.shrink( bet ),
            state.server.shrink( { lines : bet.lines, multiplier : bet.multiplier > 0 ? 0 : 1 } )
        ) );
    $multiplierChangeDoesNothing
        .map( doesNothing => ! doesNothing )
        .to( leaf.s( "canChangeMultiplier" ) );
    
    //max bet:
    const $canMaxBet = $resultBet
        .map( ({ bet, state }) =>
            //can increase lines:
            ( bet.lines < config.lines.length - 1 && state.server.price( bet ) <
                state.server.price( state.server.shrink( { lines : bet.lines + 1, multiplier : bet.multiplier } ) )
            )
            || //or
            //can increase mult:
            ( bet.multiplier < config.multipliers.length - 1 && state.server.price( bet ) <
                state.server.price( state.server.shrink( { lines : bet.lines, multiplier : bet.multiplier + 1 } ) )
            )
        )
        .distinctUntilChanged();
    $canMaxBet.to( leaf.s( "canMaxBet" ) );
    leaf.s( "maxBet" )
        .with( $resultBet, ( intent, c ) => c )
        .map( ({ bet, state }) => state.server.shrink( {
            lines : config.lines.length - 1,
            multiplier : config.multipliers.length - 1
        } ) )
        .to( $userBet );
    
    //min bet:
    $canMaxBet
        .any( $multiplierChangeDoesNothing, ( c, m ) => ! c && ( ! m ) )
        .distinctUntilChanged()
        .to( leaf.s( "canMinBet" ) );
    leaf.s( "minBet" )
        .with( $resultBet, ( m, c ) => c )
        .map( ({ bet, state }) => {
            const r = { lines : bet.lines, multiplier : 0 }
            min_mult( state, r )
            return state.server.shrink( r )
        } )
        .to( $userBet );
    
    const $finishing = space.s( "finishing" );
    //FINISH enabled:
    $finishing
        .map( finishing => finishing == FINISHING_STATES.FINISH_INVITATION )
        .to( leaf.s( "finishEnabled" ) );
    //FINISH visible:
    $finishing
        .map( finishing =>
            finishing != FINISHING_STATES.NONE
            &&
            finishing != FINISHING_STATES.RISK_INVITATION
        )
        .to( leaf.s( "finishVisible" ) );
    
    //aka "slot state": true when it's "slot state":
    parent.s( "state" )
        .any( leaf.s( "isRisk" ), ( state, isRisk ) => ({ state, isRisk }) )
        .map( ({ state, isRisk }) =>
            _.includes( [ network.TYPE.FINISH, network.TYPE.FINAL, network.TYPE.REGULAR ], state.type )
            &&
            ! isRisk
        )
        .to( leaf.s( "slotView" ) );
    
    parent.glue( "isRisk", leaf );
    parent.s( "state" )
        .map( state => state.type == network.TYPE.FREEGAME )
        .to( leaf.s( "isFreegames" ) );
    
    parent.s( "state" )
        .map( state => state.type == network.TYPE.PRECURSOR )
        .to( leaf.s( "isRoulette" ) );
    
    parent.glue( "animating", leaf );

    parent.s("slot:barrel:initiate").to(space.s("spinStart"));

    const $isProgressiveJP = space.s('isProgressiveJP', false);
    parent.s('is_progressive_jackpot').to($isProgressiveJP);

    //stop clock sound in not usual slot state
    space.s('isRisk')
        .any(space.s('isFreegames'), space.s('isJackpot'), space.s('isBonus'), space.s('isRoulette'),
            (r,f,j,b,ro) => r || f || j || b || ro)
        .filter(res => res)
        .map(() => false)
        .to(parent.s( "slot:playingClockSound" ));
    
    //all user input in current approach must be ignored by all subsequent receivers when consumed once:
    parent.s( "keyboard" )
        .with( parent.s( "is_progressive_jackpot" ), ( event, pj ) => ({ event, pj }) )
        .filter( ({ pj }) => ! pj )
        .map( ({ event }) => ({ event, consumed : false }) )
        .name( space, 'consumable_keyboard' )
        
    
    return space;
};





// WEBPACK FOOTER //
// ./src/library/ui.es6